module.exports = __webpack_public_path__ + "img/coco_qr.99161b9.png";